export const prodApiUrl = 'https://prod.tria.so';
export const SUPPORTED_EVM_CHAINS = [
    'ETH',
    'POLYGON',
    'AVALANCHE',
    'ARBITRUM',
    'BINANCE',
    'OPTIMISM',
    'FANTOM',
    'FUSE',
    'MUMBAI',
    'MANTA',
    'MANTA-TESTNET',
    'METIS',
    'METIS-TESTNET',
    'MANTLE',
    'MANTLE-TESTNET',
];
export const ALLCHAINS = [
    'ETH',
    'POLYGON',
    'AVALANCHE',
    'ARBITRUM',
    'BINANCE',
    'OPTIMISM',
    'FANTOM',
    'FUSE',
    'MUMBAI',
    'MANTA',
    'MANTA-TESTNET',
    'METIS',
    'METIS-TESTNET',
    'MANTLE',
    'MANTLE-TESTNET',
];
export const isEvmChain = (chainName) => {
    return SUPPORTED_EVM_CHAINS.includes(chainName);
};
export const isChainSupported = (chainName) => {
    return ALLCHAINS.includes(chainName);
};
// const SUBGRAPH_URL = {
//   testnet: 'https://api.thegraph.com/subgraphs/name/saurabh-threely/triadids',
//   'mainnet-staging':
//     'https://api.thegraph.com/subgraphs/name/saurabh-threely/indexer-stagingmainnet',
//   mainnet: 'https://api.thegraph.com/subgraphs/name/saurabh-threely/indexer-mainnet',
// };
// export const getSubgraphUrl = (environment: ENV = 'mainnet') => {
//   return SUBGRAPH_URL[environment];
// };
